import { render, staticRenderFns } from "./ConsultaAlertaDialog.vue?vue&type=template&id=5a520ef1&scoped=true"
import script from "./ConsultaAlertaDialog.vue?vue&type=script&lang=js"
export * from "./ConsultaAlertaDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsultaAlertaDialog.vue?vue&type=style&index=0&id=5a520ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a520ef1",
  null
  
)

export default component.exports